var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh2Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2252_3217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 3.33331V8.33332M19.1666 8.33332H14.1666M19.1666 8.33332L15.2999 4.69998C14.4043 3.80391 13.2963 3.14932 12.0792 2.79729C10.8622 2.44527 9.57584 2.40727 8.34016 2.68686C7.10447 2.96645 5.95975 3.55451 5.01281 4.39616C4.06586 5.23782 3.34756 6.30564 2.92492 7.49998M0.833252 16.6666V11.6666M0.833252 11.6666H5.83325M0.833252 11.6666L4.69992 15.3C5.59554 16.1961 6.70356 16.8506 7.92059 17.2027C9.13762 17.5547 10.424 17.5927 11.6597 17.3131C12.8954 17.0335 14.0401 16.4455 14.987 15.6038C15.934 14.7621 16.6523 13.6943 17.0749 12.5",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2252_3217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh2Svg);
export default __webpack_public_path__ + "static/media/Refresh2Svg.cc1e5247195d3bcc33a721ed44d26034.svg";
export { ForwardRef as ReactComponent };